<template>
  <div>
    <h5>Death Saves</h5>

    <div class="row tight">
      <div class="col col-sm-12 col-md">
        <under-text>
          <div slot="underline" class="cboxes">
            <i
              v-if="deathSaves.successes.includes('1st')"
              class="fa fa-check-square"
              aria-hidden="true"
              @click="splicer(deathSaves.successes, '1st')"
            ></i>
            <i
              v-else
              class="fa fa-square-o c5"
              aria-hidden="true"
              @click="pusher(deathSaves.successes, '1st')"
            ></i>
            
            <i
              v-if="deathSaves.successes.includes('2nd')"
              class="fa fa-check-square"
              aria-hidden="true"
              @click="splicer(deathSaves.successes, '2nd')"
            ></i>
            <i
              v-else
              class="fa fa-square-o c5"
              aria-hidden="true"
              @click="pusher(deathSaves.successes, '2nd')"
            ></i>
            
            <i
              v-if="deathSaves.successes.includes('3rd')"
              class="fa fa-check-square"
              aria-hidden="true"
              @click="splicer(deathSaves.successes, '3rd')"
            ></i>
            <i
              v-else
              class="fa fa-square-o c5"
              aria-hidden="true"
              @click="pusher(deathSaves.successes, '3rd')"
            ></i>
          </div>Successes
        </under-text>
      </div>
      <div class="col col-sm-12 col-md">
        <under-text>
          <div slot="underline" class="cboxes">
            <i
              v-if="deathSaves.failures.includes('1st')"
              class="fa fa-check-square"
              aria-hidden="true"
              @click="splicer(deathSaves.failures, '1st')"
            ></i>
            <i
              v-else
              class="fa fa-square-o c5"
              aria-hidden="true"
              @click="pusher(deathSaves.failures, '1st')"
            ></i>
            
            <i
              v-if="deathSaves.failures.includes('2nd')"
              class="fa fa-check-square"
              aria-hidden="true"
              @click="splicer(deathSaves.failures, '2nd')"
            ></i>
            <i
              v-else
              class="fa fa-square-o c5"
              aria-hidden="true"
              @click="pusher(deathSaves.failures, '2nd')"
            ></i>
            
            <i
              v-if="deathSaves.failures.includes('3rd')"
              class="fa fa-check-square"
              aria-hidden="true"
              @click="splicer(deathSaves.failures, '3rd')"
            ></i>
            <i
              v-else
              class="fa fa-square-o c5"
              aria-hidden="true"
              @click="pusher(deathSaves.failures, '3rd')"
            ></i>
          </div>Failures
        </under-text>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import UnderText from "../shared/_UnderText.vue";

export default {
  name: "big-boxes-death-saves",
  components: {
    UnderText
  },
  watch: {
    "deathSaves.failures"() {
      this.autoSave();
    },
    "deathSaves.successes"() {
      this.autoSave();
    }
  },
  computed: {
    ...mapGetters({ canEdit: "characters/canEdit" }),
    ...mapState({
      deathSaves: state => state.characters.current.defense.deathSaves
    })
  },
  methods: {
    ...mapActions("characters", ["autoSave"]),
    pusher(save, val) {
      if (this.canEdit) save.push(val);
    },
    splicer(save, val) {
      if (this.canEdit) save.splice(save.indexOf(val), 1);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../../../assets/_global";

.fa {
  font-size: 0.875em !important;
  width: 0.875em;
}

.cboxes {
  // color: $body-color;
  cursor: pointer;
}

h5 {
  border-bottom: 2px solid $gray-400;
  margin: 0.25em 0;
  text-align: center;
}
</style>
